<template>
    <div class="container">
        <!--form-->
        <el-form :inline="true" label-position="left" label-width="80px" :model="queryForm" ref="queryForm">
            <el-form-item label="状态" prop="status">
                <el-select v-model="queryForm.status" placeholder="请选择状态">
                    <el-option label="显示" value="1"></el-option>
                    <el-option label="不显示" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="queryForm.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="创建人" prop="owner">
                <el-input v-model="queryForm.owner" placeholder="创建人"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <el-button type="primary" v-for="o in operation" v-if="o.name == `system/notice/add`" :key="o.rule_id" @click="addNotice()">新增</el-button>
        </el-row>
        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="id"
                    label="id"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="title"
                    label="标题"
                    :show-overflow-tooltip="true"
                    width="300">
            </el-table-column>
            <el-table-column
                    prop="end_time"
                    label="结束时间"
                    width="200">
            </el-table-column>
            <el-table-column
                    prop="statusText"
                    label="状态"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="owner"
                    label="最后更新者"
                    width="">
            </el-table-column>
            <el-table-column
                    label="操作"
                    width="200">
                <template slot-scope="scope">
                    <el-button
                            @click.native.prevent="forbidUse(scope.row)"
                            type="text"
                            size="small"
                            v-for="o in operation" v-if="o.name == `system/notice/updateStatus`" :key="o.rule_id">
                        {{scope.row.status==1?'不显示':'显示'}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNo"
                :page-sizes="[2, 4, 8, 10]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        data() {
            return {
                queryForm: {
                    status: '',
                    title: '',
                    owner: '',
                    pageSize: 10,
                    pageNo: 1
                },

                tableData: [],
                loading: true,
                total: 0
            }
        },
        computed: {
            operation: function(){
                return this.$store.getters.operation
            }
        },
        created() {
            //初始化获取全部数据
            this.fetchData();

        },
        mounted() {

        },
        methods: {
            fetchData() {
                this.$api.post(this.$apiUrl.noticeList,{...this.queryForm},(res)=>{
                    this.loading = false;
                    this.total = res.data.total || 0;
                    if(res.data && res.data.notice.length>0){
                        for(let v of res.data.notice){
                            if(v.status == 1){
                                v.statusText = '显示';
                            }else{
                                v.statusText = '不显示';
                            }
                        }
                        this.tableData = res.data.notice;
                    }else{
                        this.tableData = [];
                    }
                },(res)=>{
                    this.tableData = [];
                })
            },
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.fetchData();
            },
            handleCurrentChange(val) {
                //alert(val);
                this.queryForm.pageNo = val;
                this.fetchData();
            },
            //禁用
            forbidUse(item) {
                var params = {
                    notice_id: item.id,
                    owner: this.$store.getters.username
                }
                this.$confirm('确认改变状态吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.post(this.$apiUrl.updateNoticeStatus,params,(res)=>{
                        this.fetchData();
                    })
                }).catch(() => {

                });
            },
            //新增公告
            addNotice() {
                this.$router.push({ path: `/system/notice/add/${this.$route.params.ruleId}`})
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// list.vue?310e1a7c